import React from 'react';
import Button from '../../common/primitives/Button';
import buttons from '../../common/primitives/Button.scss';

import styles from './RegionMenuTablet.scss';

import bgFlagImg from "./img/bg.png";
import enFlagImg from "./img/en.png";
import {__t} from '../../common/lang/text-resource';

class RegionMenuTablet extends React.Component {
	langsVisible = false;

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	selectLang = lang => {
		this.props.changeLanguage(lang);
		this.langsVisible = false;
		this.forceUpdate();
	};

	toggleLanguages = () => {
		this.langsVisible = !this.langsVisible;
		this.forceUpdate();
	};


	/**
	 * Set the wrapper ref
	 */
	setWrapperRef = node => {
		this.wrapperRef = node;
	};

	handleClickOutside = event => {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			if (this.langsVisible) {
				this.langsVisible = false;
				this.forceUpdate();
			}
		}
	};

	static getLangAbr(regionId) {
		switch (regionId) {
			case 'bg':
				return __t('БГ');
			case 'en':
				return __t('АЕ');
		}
	}

	static getLanguageFlag(lang) {

		if (lang === 'bg') {
			return bgFlagImg;
		} else {
			return enFlagImg;
		}
	}

	render() {
		const fullMenu =
		  <ul className={styles.container}>
			  <li className={(this.langsVisible) ? styles.regionsVisible : null}>
				  <div className={styles.currentLanguage}>
					  <Button
						onClick={this.toggleLanguages}
						name={'show_regions'}
						value={RegionMenuTablet.getLangAbr(this.props.currentLanguage.id)}/>

				  </div>
				  {
					  (this.langsVisible) ?
						<ul ref={this.setWrapperRef} className={styles.regions}>
							{
								this.props.allLanguages.map((region, key) => {
									return (
									  <li key={key}>
										  <div>
											  <img
												src={RegionMenuTablet.getLanguageFlag(region.id)}
												alt={region.name}/>
											  <Button
												name={`${region.id}_change`}
												onClick={() => this.selectLang(region.id)}
												value={region.name}
												className={buttons.buttonLink}/>
										  </div>
									  </li>
									)
								})
							}
						</ul>
						: null
				  }
			  </li>
		  </ul>;

		return fullMenu;
	}
}

export default RegionMenuTablet;